import { IFieldLayout } from '../../interfaces';

export const defaultFieldLayout: IFieldLayout = {
    labelCol: { flex: '0 1 180px' },
    valCol: { flex: '1 1 200px' },
    rowGutter: 8,
};
